module.exports = __webpack_public_path__ + "img/sieckFinesseRelease4.8640abb1.png";